export default __webpack_public_path__ + "static/media/LBR.bc3673eb.svg";